<template>
    <div id="educationExpiredModal" class="modal fade" role="dialog" tabindex="-1">
        <div class="modal-dialog modal-lg modal-dialog-centered">
            <div class="modal-content" v-if="isModalLoaded">
                <i class="fa fa-times modal-close" @click.prevent="close"></i>
                <img
                    :src="require(`../../../../img/education_expired_modal@2x.png`)"
                    :srcset="`${require(`../../../../img/education_expired_modal@1x.png`)} 1x, ${require(`../../../../img/education_expired_modal@2x.png`)} 2x, ${require(`../../../../img/education_expired_modal@3x.png`)} 3x, ${require(`../../../../img/education_expired_modal@4x.png`)} 4x`"
                />
                <div class="d-flex gap-20 flex-column align-items-center text-center">
                    <h2>{{ translate('Educational License Expired') }}</h2>
                    <div class="purple-box">
                        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
                            <path d="M9.5 0.5C14.4707 0.5 18.5 4.5293 18.5 9.5C18.5 14.4707 14.4707 18.5 9.5 18.5C4.5293 18.5 0.5 14.4707 0.5 9.5C0.5 4.5293 4.5293 0.5 9.5 0.5ZM9.5 12.2C9.2613 12.2 9.03239 12.2948 8.8636 12.4636C8.69482 12.6324 8.6 12.8613 8.6 13.1C8.6 13.3387 8.69482 13.5676 8.8636 13.7364C9.03239 13.9052 9.2613 14 9.5 14C9.73869 14 9.96761 13.9052 10.1364 13.7364C10.3052 13.5676 10.4 13.3387 10.4 13.1C10.4 12.8613 10.3052 12.6324 10.1364 12.4636C9.96761 12.2948 9.73869 12.2 9.5 12.2ZM9.5 4.1C9.27956 4.10003 9.0668 4.18096 8.90206 4.32744C8.73733 4.47393 8.63209 4.67577 8.6063 4.8947L8.6 5V10.4C8.60025 10.6294 8.68809 10.85 8.84556 11.0168C9.00304 11.1836 9.21826 11.284 9.44726 11.2975C9.67625 11.3109 9.90174 11.2364 10.0776 11.0892C10.2536 10.9419 10.3666 10.7331 10.3937 10.5053L10.4 10.4V5C10.4 4.7613 10.3052 4.53239 10.1364 4.3636C9.96761 4.19482 9.73869 4.1 9.5 4.1Z" fill="#CC8800"/>
                        </svg>
                        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
                            <path d="M12.6459 2.4437L6.88872 0.524624C6.79023 0.491792 6.68375 0.491792 6.58527 0.524624L0.828042 2.4437C0.732511 2.47554 0.649422 2.53664 0.590546 2.61834C0.531671 2.70003 0.499993 2.79818 0.5 2.89888V7.69656C0.5 7.82381 0.550547 7.94584 0.640521 8.03581C0.730495 8.12579 0.852526 8.17633 0.979769 8.17633C1.10701 8.17633 1.22904 8.12579 1.31902 8.03581C1.40899 7.94584 1.45954 7.82381 1.45954 7.69656V3.56456L3.47397 4.23563C2.93876 5.1003 2.76857 6.14202 3.00076 7.13206C3.23295 8.1221 3.84854 8.97953 4.71237 9.51609C3.63289 9.93948 2.69974 10.7053 2.01727 11.7524C1.98177 11.8052 1.95712 11.8644 1.94474 11.9268C1.93236 11.9892 1.9325 12.0534 1.94515 12.1157C1.9578 12.178 1.98271 12.2372 2.01843 12.2898C2.05415 12.3424 2.09997 12.3873 2.15322 12.4221C2.20648 12.4568 2.26611 12.4806 2.32864 12.4921C2.39118 12.5036 2.45537 12.5025 2.5175 12.489C2.57962 12.4755 2.63843 12.4497 2.69051 12.4132C2.7426 12.3768 2.78691 12.3303 2.82088 12.2766C3.72464 10.89 5.15196 10.0954 6.73699 10.0954C8.32203 10.0954 9.74934 10.89 10.6531 12.2766C10.7235 12.3811 10.8322 12.4538 10.9557 12.4789C11.0792 12.504 11.2077 12.4794 11.3133 12.4106C11.4188 12.3417 11.4931 12.2341 11.5199 12.1109C11.5468 11.9877 11.5241 11.859 11.4567 11.7524C10.7742 10.7053 9.8375 9.93948 8.76161 9.51609C9.62462 8.97955 10.2396 8.12268 10.4718 7.13336C10.7039 6.14405 10.5343 5.10304 10 4.23863L12.6459 3.35706C12.7415 3.32523 12.8246 3.26414 12.8835 3.18244C12.9424 3.10075 12.9741 3.00259 12.9741 2.90188C12.9741 2.80116 12.9424 2.70301 12.8835 2.62131C12.8246 2.53961 12.7415 2.47852 12.6459 2.4467V2.4437ZM9.6156 6.25726C9.61573 6.71235 9.50796 7.16099 9.30112 7.56637C9.09429 7.97175 8.79429 8.32231 8.42574 8.58929C8.05718 8.85627 7.63058 9.03206 7.18093 9.10225C6.73128 9.17243 6.2714 9.13501 5.83901 8.99304C5.40663 8.85108 5.01407 8.60862 4.69353 8.28556C4.373 7.96249 4.13363 7.56804 3.99506 7.13455C3.85649 6.70107 3.82268 6.24091 3.89639 5.79182C3.9701 5.34274 4.14924 4.91753 4.41911 4.55108L6.58527 5.27073C6.68375 5.30357 6.79023 5.30357 6.88872 5.27073L9.05487 4.55108C9.41937 5.04524 9.61589 5.64321 9.6156 6.25726ZM6.73699 4.3124L2.49704 2.89888L6.73699 1.48536L10.9769 2.89888L6.73699 4.3124Z" fill="#E8EAED"/>
                        </svg>
                        <strong>{{ translate('Education') }}</strong>
                    </div>
                    <div class="text-box">
                        <span class="font-size-125">{{ translate("Your educational license has expired.") }}</span>
                        <span class="font-size-125" v-html="emailText()"></span>
                    </div>
                </div>
                <div class="modal-footer">
                    <button class="btn resend-btn" @click.prevent="resend">
                        <strong>{{ translate('Resend email') }}</strong><i class="fa fa-arrow-right"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { userManager } from '../user-manager';
import { eventBus } from '../../../lib/event-bus/event-bus';
import TransFilter from '../../../qaamgo/modules/sat/components/mixins/TransFilter';
import { translate } from '../../../qaamgo/helper/translate';
import { globalLogger } from '../../../qaamgo/helper/global-logger';
import { pageNotification } from '../../../qaamgo/helper/notify';
import {setCookie} from "../../../qaamgo/helper/cookie";

  
export default {
    name: 'EducationExpiredModal',
    props: {},
    components: {},
    mixins: [TransFilter],
    data() {
      return {
        user: null,
        stateLoading: false,
        mailSent: false,
        isModalLoaded: false,
      };
    },
    mounted: function () {
      $('#educationExpiredModal').modal({show: false});
    },
    created: function () {    
      eventBus.listen('EducationExpiredModal', (data) => {
        this.user = data.user;
        this.isModalLoaded = true;
        $('#educationExpiredModal').modal('show');
      });
    },
    methods: {
        async resend() {
            this.stateLoading = true;
            globalLogger.log('edu renew banner - request mail start');

            try {
                await userManager.sendEducationalConfirmationMail();
                globalLogger.log('edu expire modal - request mail success');
            } catch (error) {
                pageNotification.showGenericErrorMessage();
                globalLogger.log('edu expire modal - request mail fail');
            } finally {
                setTimeout(() => {
                    this.stateLoading = false;
                }, 5000);
            }
            pageNotification.info(translate("We've sent a confirmation email. Time to check your inbox!"))
            this.close();
        },
        close() {
            $('#educationExpiredModal').modal('hide');

            globalLogger.log('edu expire modal - closed');

            // do not annoy user for one week
            const cookieTTL_s = 60 * 60 * 24 * 7;

            setCookie('user-edu-renew-banner-dismiss', true, cookieTTL_s);
        },
        emailText() {
            return `Please check your email at <u>${this.user?.getPlainEmail()}</u> for instructions to renew your free access for another year and continue enjoying premium features and resources designed for your academic success. Happy learning!`
        }
    },
};
</script>
<style lang="scss" scoped>
#educationExpiredModal {
    .modal-dialog {
        width: 599px;
        max-width: 95%;
        border-radius: 9px;
        overflow: hidden;
    }
  
    .modal-content {
        display: flex;
        gap: 20px;
        align-items: center;

        h2 {
            margin: 0;
            font-size: 28px;
        }
      
        img {
            width: 100%;
            border-radius: 0.3rem 0.3rem 0 0;
        }

        .modal-close {
            position: absolute;
            color: #E8EAED;
            right: 10px;
            top: 10px;
            &:hover {
                cursor: pointer;
            }
        }

        .purple-box {
            svg:first-child {
                position: absolute;
                top: -9px;
                right: -10px;
            }

            position: relative;
            display: flex;
            padding: 7px 10px;
            max-width: 112px;
            justify-content: center;
            align-items: center;
            gap: 10px;
            border-radius: 5px;
            color: #fff;
            background: #7B1FA2;
        }

        .text-box {
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 0 20px;
            text-align: center;
        }
    }
  
    .modal-footer {
        width: 100%;
        display: flex;
        padding: 20px;
        justify-content: center;
        align-items: center;
        background: #f8f9fa;
  
        .resend-btn {
            display: flex;
            height: 38px;
            width: 100%;
            padding: 7px 10px;
            justify-content: center;
            align-items: center;
            gap: 10px;
            align-self: stretch;
            border-radius: 4px;
            color: #fff;
            background: #1266F1;

            &:hover {
                cursor: pointer;
            }
        }

    }
}
</style>
  